import { InfoCircleOutlined } from "@ant-design/icons";
import { Form, Input, Select, Tooltip, Typography } from "antd"
import React from "react";
import { isEmpty } from "../../utils/helpers";
const { Paragraph } = Typography

export const UserInput = React.forwardRef(({ value, onChange, onPaste = () => { }, inputId, placeHolder, required = false, disabled = false }, ref) => {
    return (
        <Input
            autoComplete="off"
            id={inputId}
            ref={ref}
            required={required}
            disabled={disabled}
            value={value}
            onChange={onChange}
            onPaste={onPaste}
            placeholder={placeHolder}
            className="!rounded-md max-h-8 px-2 !text-sm"
        />
    );
});


export const UserSelect = React.forwardRef(({ options = [], showSearch = false, value, onChange, inputId, placeHolder, required = false, disabled = false }, ref) => {
    return (
        <Select
            id={inputId}
            ref={ref}
            showSearch={showSearch}
            filterSort={(optionA, optionB) =>
                (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
            }
            options={options}
            required={required}
            disabled={disabled}
            value={isEmpty(value) ? null : value}
            onChange={onChange}
            placeholder={placeHolder}
            className="!rounded-md max-h-8 !text-sm"
        />
    );
});


export const SimpleSelect = ({
    customClassName = null,
    className = "", size = "middle",
    name, label, showSearch = false, required = false, allowClear = true,
    handleOnchange = () => { },
    value = null, defaultValue = null,
    selectOptions = [],
    suffixIcon = null,
}) => {
    return (
        <div className="space-y-3">
            {label && <Paragraph className='!mb-0'>{label}</Paragraph>}
            <Select
                className={customClassName ?? `w-full max-h-8 !rounded-md !text-sm !border border-black/50  ${className}`}
                name={name}
                defaultValue={defaultValue}
                value={value}
                size={size}
                suffixIcon={suffixIcon}
                placeholder={`Select the ${label}`}
                showSearch={showSearch}
                required={required}
                allowClear={allowClear}
                options={selectOptions}
                onChange={handleOnchange}
                filterSort={(optionA, optionB) =>
                    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                }
            />
        </div>
    )
}

export const FormInput = ({ name, initialValue = "", type = "text", label, rules = [], placeholder = '', extraInfo = false, clear = false, disabled = false }) => {
    return (
        <Form.Item
            className="mb-2"
            name={name}
            label={label}
            rules={rules}
        >
            <Input autoComplete="off" defaultValue={initialValue} disabled={disabled} allowClear={clear} type={type} placeholder={placeholder} className="!rounded-md max-h-8 px-2 !text-sm !border border-black/50" suffix={extraInfo ?
                <Tooltip
                    classNames={{ body: '!text-xs' }}
                    title={<span>{extraInfo}</span>}
                >
                    <InfoCircleOutlined />
                </Tooltip>
                :
                null}
            />
        </Form.Item>
    );
}

export const FormSelect = ({ name, value, label, rules = [], placeholder = '', extraInfo = false, options = [], handleOnChange = () => { } }) => {
    return (
        <Form.Item
            className="mb-2"
            name={name}
            label={label}
            rules={rules}
            placeholder={placeholder}
            value={value}
        >
            <Select
                className="!rounded-lg border-black/30 !border !text-sm"
                onChange={handleOnChange}
                suffixIcon={
                    extraInfo ?
                        <Tooltip
                            classNames={{ body: '!text-xs' }}
                            title={<span>{extraInfo}</span>}
                        >
                            <InfoCircleOutlined className="text-black" />
                        </Tooltip>
                        : null
                }
                options={options}
                placeholder={placeholder}
            />
        </Form.Item>
    )
}